/**
 * Product rules for the creator hand-off from an overlay template. Keeping
 * these in one place makes the deliberately different creator experience
 * explicit instead of scattering route checks throughout the upload UI.
 */
export const OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR = {
  allPlatformsOnly: true,
  imageUploadsOnly: true,
  showTemplatePreviewBeforeMedia: true,
  disablePlatformPreviewActions: true,
  disableAutomaticMultiImageEditor: true,
  requireTemplateSaveBeforeExit: true,
  allowTemplateChange: true
} as const;
